<script>
import common from './common.vue';
export default {
  mixins: [common],
  data() {
    return {
      zhanghaoIcon: `${this.$cdnLink}/wanXin/tg2/zhanghao.png`,
      xialaIcon: `${this.$cdnLink}/wanXin/tg2/xiala.png`,
      zhanghao1Icon: `${this.$cdnLink}/wanXin/tg2/zhanghao1.png`,
      mimaIcon: `${this.$cdnLink}/wanXin/tg2/mima.png`,
      shanchuIcon: `${this.$cdnLink}/wanXin/tg2/del.png?v=1`,
      xuanzhongIcon: `${this.$cdnLink}/wanXin/tg2/xuanzhong.png`,
      weixuanzhongIcon: `${this.$cdnLink}/wanXin/tg2/weixuanzhong.png`
    }
  }
};
</script>
<style lang="scss" module>
@import "../../../assets/css/tg2.scss";

.wrap {
  @include common-window();
  > main {
    padding-top: 0.18rem;
    .accountWrap {
      position: relative;
    }
    .inputWrap {
      @include common-inputWrap();
      position: relative;
      z-index: 10;
      &.pwd {
        margin-top: 0.18rem;
        z-index: 1;
        > .leftIcon {
          width: 0.22rem;
        }
      }
    }
    .userList {
      position: absolute;
      top: 0.3rem;
      width: 4.44rem;
      left: 0;
      right: 0;
      margin: auto;
      height: 0;
      background: #f3f3f3;
      border-radius: 0 0 0.4rem 0.4rem;
      transition: height 200ms ease-in;
      perspective: 1000px;
      overflow: auto;
      z-index: 5;
      &.active {
        height: 2rem;
      }
      li {
        display: flex;
        padding: 0.15rem 0;
        margin: 0 0.3rem;
        align-items: center;
        border-bottom: 1px solid #dad9d9;
        @media screen and (-webkit-min-device-pixel-ratio: 2) {
          border-bottom: 0.5px solid #dad9d9;
        }
        @media screen and (-webkit-min-device-pixel-ratio: 3) {
          border-bottom: 0.333333px solid #dad9d9;
        }
        > img {
          width: 0.22rem;
        }
        > span {
          width: 3.5rem;
          padding-left: 0.1rem;
        }
      }
      li:nth-child(1) {
        padding-top: 0.65rem;
      }
    }
    .forget, .redirect {
      display: flex;
      color: $primary-color-1;
      justify-content: space-between;
      width: 4.44rem;
      margin: auto;
      font-size: $font-nm-1;
      > span {
        padding: 0.1rem 0.22rem 0.14rem 0.29rem;
        &:active {
          opacity: 0.8;
        }
      }
    }
    .redirect {
      > span {
        padding: 0.18rem 0.22rem 0.18rem 0.29rem;
        &:active {
          opacity: 0.8;
        }
      }
    }
    .submitBtn {
      @include common-button();
    }
    .agree {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 0.18rem;
      color: #999999;
      margin-bottom: 0.1rem;
      > img {
        width: 0.17rem;
        height: 0.17rem;
        margin-right: 0.1rem;
        margin-top: 0.02rem;
      }
    }
  }
  &.fullScreen {
    @include full-screen-window(true);
    > main {
      padding-top: 15px;
      .accountWrap {
        position: relative;
      }
      .inputWrap {
        @include full-screen-inputWrap();
        position: relative;
        z-index: 10;
        &.pwd {
          margin-top: 16px;
          z-index: 1;
          > .leftIcon {
            width: 11px;
          }
        }
      }
      .userList {
        position: absolute;
        top: 15px;
        width: 222px;
        left: 0;
        right: 0;
        margin: auto;
        height: 0;
        background: #f3f3f3;
        border-radius: 0 0 20px 20px;
        transition: height 200ms ease-in;
        perspective: 1000px;
        overflow: auto;
        z-index: 5;
        &.active {
          height: 100px;
        }
        li {
          display: flex;
          padding: 7px 0;
          margin: 0 15px;
          align-items: center;
          border-bottom: 1px solid #dad9d9;
          @media screen and (-webkit-min-device-pixel-ratio: 2) {
            border-bottom: 0.5px solid #dad9d9;
          }
          @media screen and (-webkit-min-device-pixel-ratio: 3) {
            border-bottom: 0.333333px solid #dad9d9;
          }
          > img {
            width: 11px;
          }
          > span {
            width: 175px;
            padding-left: 5px;
          }
          .del {
            // background-color: #000000;
            width: 32px;
            padding: 0 5px 0 15px;
          }
        }
        li:nth-child(1) {
          padding-top: 32px;
        }
      }
      .forget, .redirect {
        display: flex;
        color: $primary-color-1;
        justify-content: space-between;
        width: 222px;
        margin: auto;
        font-size: $font-nm;
        > span {
          padding: 6px 11px 8px 14px;
          &:active {
            opacity: 0.8;
          }
        }
      }
      .redirect {
        > span {
          padding: 11px 11px 9px 14px;
          &:active {
            opacity: 0.8;
          }
        }
      }
      .submitBtn {
        @include full-screen-button();
      }
      .agree {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 10px;
        color: #999999;
        margin-bottom: 5px;
        > img {
          width: 8px;
          height: 8px;
          margin-right: 5px;
          margin-top: 1px;
        }
      }
    }
  }
}
</style>
